<script lang="ts" module>
  export const SHAPE = {
    OCTAGON: "octagon",
    RECTANGLE: "rectangle",
  } as const
  export type Shape = (typeof SHAPE)[keyof typeof SHAPE]
</script>

<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements"

  let {
    shape = SHAPE.OCTAGON,
    children,
    ...props
  }: { shape?: Shape } & HTMLAttributes<HTMLDivElement> = $props()
</script>

<div
  {...props}
  class={[
    props.class,
    "overflow-hidden",
    {
      "rounded-[1.125rem]": shape === SHAPE.RECTANGLE,
      "shape-octagon": shape === SHAPE.OCTAGON,
    },
  ]}
>
  {@render children?.()}
</div>

<style lang="postcss">
  .shape-octagon {
    mask-image: url("./shape-octagon.svg");
    mask-position: center;
    mask-repeat: no-repeat;
  }
</style>
